import { PortletStoreApi } from './App';

export function initializeImprintLink(): void {
  initPopup();

  addOnClickFunction('login-imprint');
  addOnClickFunction('user-panel-imprint');
  addOnClickFunction('mobile-imprint');

  const popupContainer = window.document.getElementById(
    'imprint-dialog-container'
  );
  if (popupContainer) {
    popupContainer.onclick = function () {
      popupContainer.classList.remove('shown');
      popupContainer.classList.add('hidden');
    };
  }
}

function initPopup() {
  const popup = window.document.getElementById(
    'imprint-dialog-container-inner'
  );
  if (popup) {
    popup.innerHTML =
      '<iframe style="border:0;" src="' +
      PortletStoreApi.getState().url +
      '&operation=getImprint" width="100%" height="100%"></iframe>';
  }
}

function openPopup() {
  const popupContainer = window.document.getElementById(
    'imprint-dialog-container'
  );
  if (popupContainer) {
    popupContainer.classList.remove('hidden');
    popupContainer.classList.add('shown');
  }
  focusTrap(popupContainer);
  addOnEscapeFunction();
  addOnEnterFunction();
}

function closePopup() {
  const popupContainer = window.document.getElementById(
    'imprint-dialog-container'
  );
  if (popupContainer) {
    popupContainer.classList.remove('shown');
    popupContainer.classList.add('hidden');
  }
}

function addOnClickFunction(divId: string) {
  const div = window.document.getElementById(divId);
  if (div) {
    div.onclick = openPopup;
    div.onkeydown = event => {
      if (event.key === 'Enter') {
        openPopup();
      }
    };
  }
}

function addOnEscapeFunction() {
  document.onkeydown = event => {
    if (event.key === 'Escape') {
      closePopup();
    }
  };
  const iframe = document.querySelector('iframe');
  if (iframe?.contentWindow) {
    iframe.contentWindow.onkeydown = event => {
      if (event.key === 'Escape') {
        closePopup();
      }
    };
  }
}

function addOnEnterFunction() {
  const closeIcon = document.querySelector('.ehealthicon-delete.dialog-icon');
  if (closeIcon instanceof HTMLElement) {
    closeIcon.onkeydown = event => {
      if (event.key === 'Enter') {
        closePopup();
      }
    };
  }
}

function focusTrap(popupContainer: HTMLElement | null) {
  const closeIcon = document.querySelector('.ehealthicon-delete.dialog-icon');
  closeIcon?.setAttribute('tabindex', '0');
  console.log(closeIcon);
  (closeIcon as HTMLElement)?.focus();
  const iframe = document.querySelector('iframe');
  const iframeContentDoc = iframe?.contentDocument;
  const contentDocument = iframe?.contentDocument;
  const contentWindow = iframe?.contentWindow;
  const scroller = contentDocument?.getElementsByClassName('scroller')[0];
  console.log(scroller);
  scroller?.setAttribute('tabindex', '0');
  const focusableElements = iframeContentDoc?.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );
  const firstFocusableElement = closeIcon;
  const lastFocusableElement =
    focusableElements?.[focusableElements.length - 1] ?? firstFocusableElement;

  if (popupContainer) {
    popupContainer.onkeydown = function (event) {
      handleTab(event, firstFocusableElement, lastFocusableElement);
      if (closeIcon instanceof HTMLElement && contentWindow) {
        handleIframeBlur(contentWindow, closeIcon);
      }
    };
  }
}

function handleTab(
  event: KeyboardEvent,
  firstFocusableElement: Element | null,
  lastFocusableElement: Element | null
) {
  const tabPressed = event.key === 'Tab';

  if (!tabPressed) return;
  console.log(event);
  console.log(document.activeElement);
  if (document.activeElement === firstFocusableElement && event.shiftKey) {
    (lastFocusableElement as HTMLElement)?.focus();
    event.preventDefault();
  } else if (document.activeElement === lastFocusableElement) {
    (firstFocusableElement as HTMLElement)?.focus();
    event.preventDefault();
  }
}

function handleIframeBlur(
  contentWindow: Window | null,
  closeIcon: HTMLElement
) {
  contentWindow?.addEventListener('blur', function (event) {
    event.preventDefault();
    console.log('Iframe lost focus!');
    setTimeout(() => {
      closeIcon?.focus();
    }, 1);
  });
}
